import { appSlice } from './slices/app.slice';
import { authSlice } from './slices/auth.slice';
import { clientUserSlice } from './slices/client.slice';
import { adminUserSlice } from './slices/admin.slice';
import { roleSlice } from './slices/roles.slice';
import { permissionSlice } from './slices/permissions.slice';
import { moduleSlice } from './slices/module.slice';
import { conclusionRecommendationSlice } from './slices/conclusion-recommendation.slice';
import { unitConversionSlice } from './slices/unit-conversion.slice';
import { optionsSlice } from './slices/options.slice';
import { bannerSlice } from './slices/banner.slice';
import { bannerHeaderSlice } from './slices/banner-header.slice';
import { pageSlice } from './slices/page.slice';
import { physicalActivitySlice } from './slices/regulate-level-physical-activity.slice';
import { conclusionDropdownSlice } from './slices/conclusion-dropdown.slice';
import { healthStatusSlice } from './slices/health-status.slice';
import { importHistorySlice } from './slices/import-history.slice';
import { dishSlice } from './slices/dish.slice';
import { foodSlice } from './slices/food.slice';
import { productSlice } from './slices/product.slice';
import { comboFoodSlice } from './slices/combo-food.slice';
import { nutritionStandardSlice } from './slices/nutrition-standards-management.slice';
import { adviceRecommendSlice } from './slices/adivce-recommend.slice';
import { nutritionalMenuCalculatorSlice } from './slices/nutritional-menu-calculator.slice';
import { chatboxSlice } from './slices/chatbox.slice';
import { notificationSlice } from './slices/notification.slice';

export const slices = [
  appSlice,
  authSlice,
  clientUserSlice,
  roleSlice,
  permissionSlice,
  adminUserSlice,
  moduleSlice,
  conclusionRecommendationSlice,
  unitConversionSlice,
  optionsSlice,
  bannerSlice,
  bannerHeaderSlice,
  pageSlice,
  physicalActivitySlice,
  conclusionDropdownSlice,
  dishSlice,
  foodSlice,
  productSlice,
  healthStatusSlice,
  importHistorySlice,
  dishSlice,
  comboFoodSlice,
  nutritionStandardSlice,
  adviceRecommendSlice,
  nutritionalMenuCalculatorSlice,
  chatboxSlice,
  notificationSlice
];
